import { setLocale } from 'yup';
import i18next from 'i18next';
import { esConfig } from './yup.configEs';
import { enConfig } from './yup.configEn';

export const initYupLocale = () => {
  const applyLocale = (lng) => {
    if (lng === 'en') {
      setLocale(enConfig);
    } else {
      setLocale(esConfig);
    }
  };

  applyLocale(i18next.language);

  i18next.on('languageChanged', applyLocale);
};
